import React, { createContext, useState, useContext, useEffect } from 'react';

export const SUPPORTED_LANGS = [
  { code: 'en',    label: 'EN · English' },
  { code: 'zh',    label: '中文 · 简体' },
  { code: 'zh-TW', label: '中文 · 繁體' },
  { code: 'fr',    label: 'FR · Français' },
  { code: 'de',    label: 'DE · Deutsch' },
  { code: 'ja',    label: 'JA · 日本語' },
  { code: 'ko',    label: 'KO · 한국어' },
  { code: 'ar',    label: 'AR · العربية' },
];

const HTML_LANG = {
  en: 'en', zh: 'zh-CN', 'zh-TW': 'zh-TW', fr: 'fr',
  de: 'de', ja: 'ja', ko: 'ko', ar: 'ar',
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    document.documentElement.lang = HTML_LANG[language] || 'en';
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => (prev === 'en' ? 'zh' : 'en'));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
